<mat-card>
  <mat-card-content>
    <mat-card-title>Products Performance</mat-card-title>
    <div class="m-t-10 table-responsive">
      <table mat-table [dataSource]="dataSource" class="table product-table no-wrap w-100">
        <ng-container matColumnDef="items">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let productelement" class="p-l-0">
            <div class="d-flex align-items-center">
              <img
                class="rounded-lg"
                alt="products"
                width="90"
                height="70"
                [src]="productelement.imagePath"
              />
              <div class="m-l-15">
                <h6 class="fw-medium mat-subheading-2 m-b-5 m-t-0 lh-sm">
                  {{ productelement.Name }}
                </h6>
                <small class="mat-body-1 text-muted">{{
                  productelement.Category
                }}</small>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="reviews">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let productelement" class="p-l-0">
            <h6 class="mat-body-1 fw-medium m-0 m-b-5">
              {{ productelement.Review | titlecase }}
            </h6>
            <ng-template [ngIf]="productelement.Review === 'good'">
                <mat-progress-bar mode="determinate" color="accent" class="m-b-5" value="{{productelement.Percent}}"></mat-progress-bar>
            </ng-template>
            <ng-template [ngIf]="productelement.Review === 'bad'">
                <mat-progress-bar mode="determinate" color="primary" class="m-b-5" value="{{productelement.Percent}}"></mat-progress-bar>
            </ng-template>
            
            <small class="mat-body-1 text-muted">{{
                productelement.Percent
              }}% sold</small>
          </td>
        </ng-container>

        <ng-container matColumnDef="earnings">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let productelement" class="p-l-0">
            <small class="mat-body-1 text-muted">Earnings</small>
              <h6 class="fw-medium mat-subheading-2 m-b-5 m-t-0 lh-sm">
                ${{ productelement.Earnings }}
              </h6>
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let productelement" class="p-r-0">
            <a
              (click)="openDialog('Delete', productelement)"
              class="m-r-10 cursor-pointer"
            >
              <i-feather name="trash" class="feather-20 text-muted"></i-feather>
            </a>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>
